"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookiesCategory;
(function (CookiesCategory) {
    CookiesCategory["StrictlyNecessary"] = "1";
    CookiesCategory["Performance"] = "2";
    CookiesCategory["Functional"] = "3";
    CookiesCategory["Targeting"] = "4";
    CookiesCategory["SocialMedia"] = "5";
    CookiesCategory["Unrecognized"] = "-1";
})(CookiesCategory = exports.CookiesCategory || (exports.CookiesCategory = {}));
var ConsentMode;
(function (ConsentMode) {
    ConsentMode[ConsentMode["NOOP"] = 0] = "NOOP";
    ConsentMode[ConsentMode["DEFAULT"] = 1] = "DEFAULT";
    ConsentMode[ConsentMode["STRICT"] = 2] = "STRICT";
})(ConsentMode = exports.ConsentMode || (exports.ConsentMode = {}));
